const columns = [
  {title: "Mã thuốc", dataIndex: "idThuoc", key: "idThuoc", align: "center"},
  {title: "Tên thuốc", dataIndex: "tenThuoc", key: "tenThuoc"},
  {title: "Nồng độ", dataIndex: "nongDo", key: "nongDo"},
  {title: "Hoạt chất", dataIndex: "hoatChat", key: "hoatChat"},
  {title: "Số lượng", dataIndex: "soLuong", align: "right"},
  {title: "Đơn vị", dataIndex: "donVi", key: "donVi"},
  {title: "Liều dùng", dataIndex: "lieuDung", key: "lieuDung"},
];
export {columns};
